import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'

initComponent('.js-blog-product-spotlight', section => {
  const slider = section.querySelector('.js-blog-product-spotlight-swiper')

  const swiper = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 16,
    centeredSlides: true,
    freeMode: false,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        loop: false,
        slidesOffsetBefore: 0,
        centeredSlides: false,
        slidesOffsetAfter: 0,
        spaceBetween: 16,
        allowTouchMove: false,
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})
